userCheckResults